function runWidget({baseUrl, phoneNumber, startText, brand}) {
  const brandName = brand?.name || '99Digital';
  const brandLogo = brand?.logo || 'logo_thumbnail.png';
  const brandLink = brand?.link || 'https://99digital.co.il';
  const locale = window.navigator.language.replace('-', '_');
  const option = {
    brandSetting: {
      autoShow: false,
      backgroundColor: "#fff",
      borderRadius: "25",
      brandImg: baseUrl + "/whatsapp.png",
      brandImgData: null,
      brandName: "WhatsApp",
      brandText: (locale === 'he' ? "מופעל על ידי " : "Powered by " ) + brandName,
      brandColor: '#3c4858',
      brandSubTitle: "",
      ctaText: locale === 'he' ? "התחל צ ' אט" : "Start Conversation",
      welcomeText: "",
      startText,
      phoneNumber
    },
    chatButtonSetting: {
      backgroundColor: "#4dc248",
      backgroundColor2: "#1F93FF",
      borderRadius: "5",
      ctaText: "",
      marginLeft: "22",
      marginRight: "22",
      marginBottom: "18",
      position: isRtl() ? "left" : "right"
    },
  }

  if (isRtl()) document.dir = 'rtl'
  if(window.jQuery){
    initWidget();
  }else{
    var script = document.createElement("SCRIPT");
    script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
    script.type = 'text/javascript';
    script.onload = function() {
      initWidget();
    };
    document.getElementsByTagName("head")[0].appendChild(script);
  }
  function isRtl() {
    return locale === 'he'
  }
  function initWidget(){
    jQuery('body').append(`<div id="whatsapp_chat_widget">
            <div id="wa-widget-send-button">
            <svg data-v-242498a4="" width="36" height="36" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z" fill="white"></path></svg>
                <div style="color: white; font-size: 18px">${option.chatButtonSetting.ctaText}</div>
            </div>
        </div>`);
    jQuery('#whatsapp_chat_widget').append(`
            <div class='wa-chat-box'>
                <div class='wa-chat-box-header'>
                    <img class='wa-chat-box-brand' src='${option.brandSetting.brandImg}'/>
                    <div class='wa-chat-box-brand-text'>
                        <div class='wa-chat-box-brand-name'>${option.brandSetting.brandName}</div>
                        <div class='wa-chat-box-brand-subtitle'>${option.brandSetting.brandSubTitle}</div>
                    </div>
                    <div class="wa-chat-bubble-close-btn">
                      <svg width="16" height="16" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon icon--font dismiss"><path d="m4.397 4.554.073-.084a.75.75 0 0 1 .976-.073l.084.073L12 10.939l6.47-6.47a.75.75 0 1 1 1.06 1.061L13.061 12l6.47 6.47a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073L12 13.061l-6.47 6.47a.75.75 0 0 1-1.06-1.061L10.939 12l-6.47-6.47a.75.75 0 0 1-.072-.976l.073-.084-.073.084Z" fill="currentColor"></path></svg>
                    </div>
                </div>

                <div class='wa-chat-box-content'>
                <!--    <div class='wa-chat-box-content-chat'>-->
                <!--        <div class='wa-chat-box-content-chat-brand'>${option.brandSetting.brandName}</div>-->
                <!--        <div class='wa-chat-box-content-chat-welcome'>${option.brandSetting.welcomeText.replace(/\n/g, "<br/>")}</div>-->
                <!--    </div>-->
                </div>

                <div class='wa-chat-box-send'>
                    <a role="button" target="_blank" href="https://api.whatsapp.com/send?phone=${option.brandSetting.phoneNumber.replace(/\+/g, "")}&text=${option.brandSetting.startText?option.brandSetting.startText:""}" title="WhatsApp" class="wa-chat-box-content-send-btn"><svg width="20" height="20" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" class="wa-chat-box-content-send-btn-icon">
                        <span class="wa-chat-box-content-send-btn-text">${option.brandSetting.ctaText}</span>
                    </a>
                    <div class='wa-chat-box-poweredby'>
                    <a class="branding-link" href="${brandLink}" target="_blank">
                      <img src="${baseUrl}/brand-assets/${brandLogo}" class="branding-image">
                      <span>${option.brandSetting.brandText}</span>
                    </a>
                </div>
            </div>
        `);
    if(option.brandSetting.autoShow){
      jQuery(".wa-chat-box").css("display", "block");
    }else{
      jQuery(".wa-chat-box").css("display", "none");
    }
    jQuery("#whatsapp_chat_widget").on('click', '.wa-chat-bubble-close-btn', function(){
      jQuery(".wa-chat-box").css("display", "none");
    })
    jQuery("#whatsapp_chat_widget").on('click', '#wa-widget-send-button', function(){
      jQuery(".wa-chat-box").css("display", "block");
    })
  }
  var styles = `
        #whatsapp_chat_widget{
        }
        .wa-chat-box-content-send-btn-text{
            margin-left: 8px;
            margin-right: 8px;
            z-index: 1;
            color: rgb(255, 255, 255);
        }
        .wa-chat-box-content-send-btn-icon{
            width: 16px;
            height: 16px;
            fill: rgb(255, 255, 255);
            z-index: 1;
            flex: 0 0 16px;
        }
        .wa-chat-box-content-send-btn{
            text-decoration: none;
            color: rgb(255, 255, 255)!important;
            font-size: 15px;
            font-weight: 700;
            line-height: 20px;
            cursor: pointer;
            position: relative;
            display: flex;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;
            -webkit-appearance: none;
            padding: 8px 12px;
            border-radius: ${option.chatButtonSetting.borderRadius}px;
            border-width: initial;
            border-style: none;
            border-color: initial;
            border-image: initial;
            background-color: ${option.chatButtonSetting.backgroundColor2}!important;
            margin: 20px;
            overflow: hidden;
        }
        .wa-chat-box-send{
            background-color:white;

        }
        .wa-chat-box-content-chat-brand{
            font-size: 13px;
            font-weight: 700;
            line-height: 18px;
            color: rgba(0, 0, 0, 0.4);
        }
        .wa-chat-box-content-chat-welcome{
            font-size: 14px;
            line-height: 19px;
            margin-top: 4px;
            color: rgb(17, 17, 17);
        }
        .wa-chat-box-content-chat{
            background-color: white;
            display: inline-block;
            margin: 20px;
            padding: 10px;
            border-radius: 10px;
        }
        .wa-chat-box-content{
            min-height: 9rem;
            background: url(${baseUrl}/brand-assets/chat_background.jpg);

        }
        .wa-chat-bubble-close-btn{
            cursor: pointer;
            position: absolute;
            right: 20px;
            top: 20px;
        }
        [dir=rtl] .wa-chat-bubble-close-btn{
            right: unset;
            left: 20px;
        }
        .wa-chat-box-brand-text{
            margin-left: 20px;
        }
        .wa-chat-box-brand-name{
            font-size: 16px;
            font-weight: 700;
            line-height: 20px;
        }
        .wa-chat-box-brand-subtitle{
            font-size: 13px;
            line-height: 18px;
            margin-top: 4px;
        }

        .wa-chat-box-header{
            height: 100px;
            max-height: 100px;
            min-height: 100px;
            background-color: ${option.brandSetting.backgroundColor};
            color: ${option.brandSetting.brandColor};
            border-radius: 10px 10px 0px 0px;
            display:flex;
            align-items: center;
        }
        .wa-chat-box-brand{
            margin-left: 20px;
            width: 50px;
            height: 50px;
        }
        .wa-chat-box{
            background-color:white;
            z-index: 16000160 !important;
            margin-bottom: 60px;
            width: 400px;
            position: fixed !important;
            bottom: ${option.chatButtonSetting.marginBottom}px !important;
            ${option.chatButtonSetting.position == "left" ? "left : "+option.chatButtonSetting.marginLeft+"px" : "right : "+option.chatButtonSetting.marginRight+"px"};
            border-radius: 10px;
            box-shadow: 2px 2px 6px rgba(0,0,0,0.4);
            font: 400 normal 15px/1.3 -apple-system, BlinkMacSystemFont, Roboto, Open Sans, Helvetica Neue, sans-serif;
        }
        #wa-widget-send-button {
            margin: 0 0 ${option.chatButtonSetting.marginBottom}px 0 !important;
            padding-left: ${option.chatButtonSetting.ctaText?"15px":"0px"};
            padding-right: ${option.chatButtonSetting.ctaText?"15px":"0px"};
            position: fixed !important;
            z-index: 16000160 !important;
            bottom: 0 !important;
            text-align: center !important;
            height: 50px;
            min-width: 50px;
            border-radius: 25px;
            visibility: visible;
            transition: none !important;
            background-color: ${option.chatButtonSetting.backgroundColor};
            box-shadow: 2px 2px 6px rgba(0,0,0,0.4);
            ${option.chatButtonSetting.position == "left" ? "left : "+option.chatButtonSetting.marginLeft+"px" : "right : "+option.chatButtonSetting.marginRight+"px"};
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content:center;
        }
        .wa-messenger-svg-whatsapp{
            fill: white;
            width: 41px;
            height: 50px;
            stroke: none;
        }
        .wa-chat-box-poweredby{
            margin-bottom: 15px;
            margin-top: -10px;
            font-size: 12px;
            display: flex;
            justify-content: center;
        }
        .branding-link {
            align-items: center;
            color: #96979c;
            cursor: pointer;
            display: flex;
            filter: grayscale(1);
            flex-direction: row;
            font-size: 0.5rem;
            line-height: 1.5;
            opacity: 0.9;
            text-decoration: none;
        }
        .branding-image {
            max-width: 0.5rem;
            max-height: 0.5rem;
            margin-right: 0.2rem;
        }
        .branding-link:hover      {
            filter: grayscale(0);
            opacity: 1;
            color: #6e6f73;
        }

        @media only screen and (max-width: 600px) {
            .wa-chat-box
            {
                width: auto;
                position: fixed !important;
                right: 20px!important;
                left: 20px!important;
            }
        }
    `

  var styleSheet = document.createElement("style")
  styleSheet.type = "text/css"
  styleSheet.innerText = styles
  document.getElementsByTagName("head")[0].appendChild(styleSheet);
}

window.onlineWaWidget = {
  run: runWidget,
};
